import { Component, computed, HostListener, input, signal } from '@angular/core'
import { isInView } from '../../core/util/isInView.util'

@Component({
  selector: 'app-scroll-to-selector',
  imports: [],
  templateUrl: './scroll-to-selector.component.html',
  styleUrl: './scroll-to-selector.component.scss',
})
export class ScrollToSelectorComponent {
  protected selector = input.required<string>()

  /**
   * Default is LARGE_BLUE
   */
  protected scrollArrowStyle = input<ScrollArrowStyle>(ScrollArrowStyle.LARGE_BLUE)

  protected iconClassName = computed(() => {
    if (this.scrollArrowStyle() === ScrollArrowStyle.LARGE_BLUE) {
      return 'scrollToSelector__iconBigBlue'
    }
    return 'scrollToSelector__iconSmallPurple'
  })

  protected isInView = signal(false)

  @HostListener('window:scroll')
  @HostListener('window:resize')
  protected onScroll(): void {
    this.isInView.set(!!isInView(this.selector()))
  }

  protected scrollToSelector(): void {
    const element = document.querySelector(this.selector())
    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    })
  }
}

export enum ScrollArrowStyle {
  LARGE_BLUE = 1,
  SMALL_PURPLE = 2,
}
